import { ApiService } from 'js/src/client';
import { Toast } from 'js/src/components/common/Toast';
import {
    receivePremiumMediaStatus,
    receivePremiumMediaUsage,
} from 'js/src/data/premium-media/premium-media-actions';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';

export function updatePremiumMediaUsage() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        return new Promise<void>((resolve, reject) => {
            ApiService.premiumMediaCreditCheckCreate({
                body: {
                    video_data: JSON.stringify(getState().undoable.present.video_data),
                },
            })
                .then((response) => {
                    dispatch(
                        receivePremiumMediaUsage({
                            credits: response.data.credits_in_data,
                        }),
                    );
                    resolve();
                })
                .catch((error: unknown) => {
                    ErrorReporter.capture(error);
                    Toast.error('Failed to get premium media usage');
                });
        });
    };
}

export function loadPremiumMediaStatus() {
    return (dispatch: AppDispatch) => {
        return new Promise<void>((resolve, reject) => {
            ApiService.pricingPremiumMediaRetrieve()
                .then((response) => {
                    dispatch(
                        receivePremiumMediaStatus({
                            total_active_credit_availability:
                                response.data.total_active_credit_availability,
                            total_active_credit_expense: response.data.total_active_credit_expense,
                        }),
                    );
                    resolve();
                })
                .catch((err: unknown) => {
                    ErrorReporter.capture(err);
                    Toast.error('Failed to load premium media status');
                    reject(err);
                });
        });
    };
}
